export const damageConstants = {
    SET_DAMAGE: 'DAMAGE_SET_DAMAGE',
    SET_DAMAGE_PLOT: 'DAMAGE_SET_DAMAGE_PLOT',
    UPDATE_DAMAGE_PLOT: 'DAMAGE_UPDATE_DAMAGE_PLOT',
    SET_PRODUCT_TYPE: 'DAMAGE_SET_PRODUCT_TYPE',
    SET_PRODUCT: 'DAMAGE_SET_PRODUCT',
    SET_HIGHLIGHTED_DAMAGE_PLOT: 'DAMAGE_SET_HIGHLIGHTED_DAMAGE_PLOT',
    SET_HIGHLIGHTED_DAMAGE_MEPAR: 'DAMAGE_SET_HIGHLIGHTED_DAMAGE_MEPAR',
};
